import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { Button, TextField } from '@mui/material';
import { useCallback } from 'react';
import moment from "moment";
import AgGridTable from 'src/app/main/utilities/AgGridTable';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon/FuseSvgIcon';
import uploadSingleFilePopup from '../upload-component/uploadSingleFilePopup';
import { useParams } from 'react-router-dom';
import CustomDatePicker from 'src/app/main/utilities/CustomDatePicker';


/* -------------------------------- handoverDate -------------------------------- */
const handoverDate = forwardRef((props, ref) => {
    const refDatePicker = useRef();
    const [error, setError] = useState("")
    const [handoverDate, setHandoverDate] = useState(null);

    const handleHandoverDateChange = (newValue) => {
        setHandoverDate(moment(newValue).format('YYYY-MM-DD'));
    };

    useEffect(() => {
        if (props.data.handoverDate) {
            setHandoverDate(props.data.handoverDate);
        }
    }, [props.data])

    useImperativeHandle(ref, () => {
        return {
            getValue() {
                if (handoverDate !== null) {
                    return moment(handoverDate).format('YYYY-MM-DD');

                }
            }
        };
    });

    return (
        <CustomDatePicker
            format={'dd-MM-yyyy'}
            name={'handoverDate'}
            value={handoverDate ? handoverDate : (!props.value ? null : props.value)}
            handleChange={handleHandoverDateChange}
            ref={refDatePicker}
        />
    );
});
/* -------------------------------- validUntil -------------------------------- */
const validUntil = forwardRef((props, ref) => {
    const refDatePicker = useRef();
    const [error, setError] = useState("")
    const [validUntil, setValidUntil] = useState(null);

    const handleValidUntilChange = (newValue) => {
        setValidUntil(moment(newValue).format('YYYY-MM-DD'));
    };

    useEffect(() => {
        if (props.data.validUntil) {
            setValidUntil(props.data.validUntil);
        }
    }, [props.data])

    useImperativeHandle(ref, () => {
        return {
            getValue() {
                if (validUntil !== null) {
                    return moment(validUntil).format('YYYY-MM-DD');

                }
            }
        };
    });

    return (
        <CustomDatePicker
            format={'dd-MM-yyyy'}
            name={'validUntil'}
            value={validUntil ? validUntil : (!props.value ? null : props.value)}
            handleChange={handleValidUntilChange}
            ref={refDatePicker}
        />
    );
});
/* -------------------------------- retunedDate -------------------------------- */
const retunedDate = forwardRef((props, ref) => {
    const refDatePicker = useRef();
    const [error, setError] = useState("")
    const [retunedDate, setRetunedDate] = useState(null);

    const handleRetunedDateChange = (newValue) => {
        setRetunedDate(moment(newValue).format('YYYY-MM-DD'));
    };

    useEffect(() => {
        if (props.data.retuned) {
            setRetunedDate(props.data.retuned);
        }
    }, [props.data]);

    useImperativeHandle(ref, () => {
        return {
            getValue() {
                if (retunedDate !== null) {
                    return moment(retunedDate).format('YYYY-MM-DD');

                }
            }
        };
    });

    return (
        <CustomDatePicker
            format={'dd-MM-yyyy'}
            name={'retunedDate'}
            value={retunedDate ? retunedDate : (!props.value ? null : props.value)}
            handleChange={handleRetunedDateChange}
            ref={refDatePicker}
        />
    );
});

const assetData = [
    { asset: "Trademarks", details: "", handoverDate: "", validUntil: "", retuned: "", status: "", cost: "", attachFile: "", remarks: "" },
]

const AssetDetail = ({ personalInfo, setSnackState, setSuccessMsg }) => {
    const gridRef = useRef();
    const params = useParams();
    const [gridApi, setGridApi] = useState(null);
    const [asset, setAsset] = useState(assetData);
    const [uploadDocument, setUploadDocument] = useState([]);
    const handleDateFormat = (props) => {
        return props.value && moment(props.value).format('DD-MM-YYYY')
    }
    
    const [assetColumnDefs, setAssetColumnDefs] = useState([
        { field: 'file', enableRowGroup: false, hide: true, editable: false },
        { field: 'asset', enableRowGroup: true },
        { field: 'details', enableRowGroup: true },
        { field: 'handoverDate', enableRowGroup: true, cellEditor: handoverDate, cellRenderer: handleDateFormat },
        { field: 'validUntil', enableRowGroup: true, cellEditor: validUntil, cellRenderer: handleDateFormat },
        { field: 'returned', enableRowGroup: true, cellEditor: retunedDate, headerName: "Returned Date" },
        { field: 'status', enableRowGroup: true },
        { field: 'cost', enableRowGroup: true },
        { field: 'remarks', enableRowGroup: true },
        {
            field: 'uploadFile', enableRowGroup: true, cellEditor: uploadSingleFilePopup, cellStyle: {
                textAlign: 'right',
            }
        },
    ]);

    const onGridReady = useCallback((params) => {
        setGridApi(params);
        var columnToolPanel = gridRef.current.api.getToolPanelInstance('columns');
        columnToolPanel.expandColumnGroups();
    }, [asset]);

    /*------------------------------Inline Row editing options-------------------------------*/

    const onBtAdd = useCallback((event) => {
        const newRow = {}
        const newRowDate = gridRef.current.api.applyTransaction({ add: [newRow] });
        const RowIndex = newRowDate.add[0].rowIndex;
        // let index = asset.findIndex((row) => row.id === event.node.data.id);
        // const nextIndex = index + 1;
        // asset.splice(RowIndex, 0, newRow);
        gridRef.current.api.refreshCells();

        setTimeout(() => {
            gridRef.current.api.setFocusedCell(RowIndex, 'asset')
            gridRef.current.api.startEditingCell({
                rowIndex: RowIndex,
                colKey: 'asset',
            });
        }, 800);
    }, []);
    const onBtStartEditing = useCallback((event) => {
        const index = event.node.rowIndex;
        gridRef.current.api.setFocusedCell(index, 'asset')
        gridRef.current.api.startEditingCell({
            rowIndex: index,
            colKey: 'asset',
        });

    }, []);
    const onBtDeleteRow = useCallback((event) => {
        const selectedRow = gridApi.api.getSelectedRows();
        asset.splice(event.node.rowIndex, 1);
        gridRef?.current?.api.applyTransaction({ remove: selectedRow });
    }, [gridApi, asset])

    const getContextMenuItems = (event) => {
        const data = event?.node?.data;
        var result = [
            {
                name: "Add Row",
                icon: '<span><i class="material-icons style="font-size: 18px">perm_identity</i></span>',
                action: () => {
                    onBtAdd(event);
                },
            },
            {
                name: "Edit Row",
                disabled: !data,
                icon: '<span><i class="material-icons" style="font-size: 18px">edit</i></span>',
                action: () => {
                    onBtStartEditing(event);
                },
            },
            {
                name: "Delete Row",
                disabled: !data,
                icon: '<span><i class="material-icons" style="font-size: 18px">delete</i></span>',
                action: () => {
                    onBtDeleteRow(event);
                },
            },
        ];
        return result;
    };

    const onRowValueChanged = useCallback(async (event) => {
        const { data } = event.node;
        const model = {
            id: data.docId ? data.docId : "",
            asset: data.asset,
            details: data.details,
            handoverDate: data.handoverDate,
            validUntil: data.validUntil,
            retuned: data.retuned,
            empId: params.id ? params.id : personalInfo.employeeId,
            status: data.status,
            cost: data.cost,
            file: data.file,
            rowIndex: event.node.rowIndex,
            remarks: data.remarks
        }
        if (params.id) {
            if (data.docId) {
                if (uploadDocument.filter(doc => doc.rowIndex === event.node.rowIndex).length > 0) {
                    const updatedData = uploadDocument.map((item) => {
                        if (item.id === event.node.data.id) {
                            item.asset = data.asset,
                                item.details = data.details,
                                item.handoverDate = data.handoverDate,
                                item.validUntil = data.validUntil,
                                item.retuned = data.retuned,
                                item.empId = params.id ? params.id : personalInfo.employeeId,
                                item.status = data.status,
                                item.cost = data.cost,
                                item.file = data.file,
                                item.remarks = data.remarks
                        }
                        return item;
                    });
                    setUploadDocument(updatedData);
                } else {
                    setUploadDocument([...uploadDocument, model]);
                }
            } else {
                if (uploadDocument.filter(doc => doc.rowIndex === event.node.rowIndex).length > 0) {
                    const updatedData = uploadDocument.map((item) => {
                        if (item.rowIndex === event.node.rowIndex) {
                            item.asset = data.asset,
                                item.details = data.details,
                                item.handoverDate = data.handoverDate,
                                item.validUntil = data.validUntil,
                                item.retuned = data.retuned,
                                item.empId = params.id ? params.id : personalInfo.employeeId,
                                item.status = data.status,
                                item.cost = data.cost,
                                item.file = data.file,
                                item.remarks = data.remarks
                        }
                        return item;
                    })
                    setUploadDocument(updatedData);
                } else {
                    setUploadDocument([...uploadDocument, model]);
                }
            }

        } else {
            if (uploadDocument.filter(doc => doc.rowIndex === event.node.rowIndex).length > 0) {
                const updatedData = uploadDocument.map((item) => {
                    if (item.rowIndex === event.node.rowIndex) {
                        item.asset = data.asset,
                            item.details = data.details,
                            item.handoverDate = data.handoverDate,
                            item.validUntil = data.validUntil,
                            item.retuned = data.retuned,
                            item.empId = params.id ? params.id : personalInfo.employeeId,
                            item.status = data.status,
                            item.cost = data.cost,
                            item.file = data.file,
                            item.remarks = data.remarks
                    }
                    return item;
                })
                setUploadDocument(updatedData);
            } else {
                setUploadDocument([...uploadDocument, model]);
            }
        }

    }, [uploadDocument, personalInfo]);

    /*---------------------------------------------------------------------------------------------*/

    return (
        <div>
            <div className='flex justify-end mb-16'>
                <Button
                    // onClick={handleSubmit}
                    variant="contained"
                    color="warning"
                >
                    <FuseSvgIcon>heroicons-solid:document</FuseSvgIcon>
                    Save Document
                </Button>
            </div>
            <div style={{ height: "500px" }}>
                <AgGridTable
                    columnDefs={assetColumnDefs}
                    rowData={asset}
                    onRowValueChanged={onRowValueChanged}
                    onGridReady={onGridReady}
                    gridRef={gridRef}
                    editable={true}
                    editType={'fullRow'}
                    paginationPageSize={10}
                    getContextMenuItems={getContextMenuItems}
                    saveGridStateName={'assetInfo'}
                />
            </div>
        </div>
    )
}

export default AssetDetail